import { Component, ViewChild, Injector, Output, EventEmitter, ViewEncapsulation} from '@angular/core';
import { GetWorkFlowStepByItemDetailForViewDto } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppComponentBase } from '@shared/common/app-component-base';
import {WorkFlowItemDetailComponent} from './workFlowItem-detail.component';   		
@Component({
    selector: 'workFlowItemDetailModal',
    styleUrls: ['./workFlowItem-detail-modal.component.less'],
    templateUrl: './workFlowItem-detail-modal.component.html',
    encapsulation: ViewEncapsulation.None
})
export class WorkFlowItemDetailModalComponent extends AppComponentBase {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @ViewChild('workFlowItemDetail') workFlowItemDetail: WorkFlowItemDetailComponent;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;


    title = '';
    description = '';
    groupDetailByStep = [];


    constructor(
        injector: Injector
    ) {
        super(injector);
    }
    
    show(listDetail: GetWorkFlowStepByItemDetailForViewDto[],itemTilte?:string): void {
    
        this.title = itemTilte;

        this.active = true;
        this.workFlowItemDetail.show(listDetail);
        this.modal.show();
        
        
        
    }

    save(): void {
            this.saving = true;
            
			this.modalSave.emit(this.description);
			this.close();
            
    }

    




    close(): void {
        this.active = false;
        this.modal.hide();
    }
    
     ngOnInit(): void {
        
     }   
}
